import Notifier from 'common/helpers/Notifier';
import { coreApi } from 'src/api/config';

/**
 * Fetches organization information based on provided IDs.
 * @param {Array<string>} organizationsIds - Array of organization IDs.
 * @returns { organizations: Array } - Organization data.
 */

async function fetchOrganizationsInfo(organizationsIds = []) {
  try {
    const response = organizationsIds.length > 0 ?
      await coreApi.query('provider', { ids: organizationsIds }) :
      await Promise.resolve({ data: { data: [] } });

    const {
      data: { data: organizations },
    } = response;

    return { organizations };
  } catch (error) {
    Notifier.handleErrors(error);
    return { organizations: [] };
  }
}

export default fetchOrganizationsInfo;
